Ext.define('SA.view.sidebar.data.DataCategoriesGrid', {
    alias: 'widget.data-categories-grid',
    extend: 'SA.view.sidebar.SidebarList',

    cls: 'sa-data-categories-grid',

    getImportsItemEl() {
        return this.getItemEl(SA.data.CountryCategoryList.getImportsCategoryId());
    },

    getNonImportsItemEls() {
        var importsItem = this.getImportsItemEl();

        return this.el.query('.sa-sidebar-list-item').filter(item => item !== importsItem);
    },

    setCategories(categories) {
        var items = categories.map(category => {
            return {
                disabled: !category.available,
                icon: 'sa-icon-category-' + category.id.replace(/[^a-z]+/g, '-'),
                id: category.id,
                text: category.name
            };
        });

        this.setItems(items);

        this.el.query('.sa-sidebar-list-item')
            .slice(0, 3)
            .forEach(item => Ext.fly(item).addCls('sa-sidebar-list-item-lower-content'));
    }
});
